<div>
  <h3 nz-typography nzType="danger">
    მნიშვნელოვანი განახლება
  </h3>

  ძვირფასო მომხმარებელო, პირველ რიგში მადლობა ჩვენი ერთგულებისთვის.

  <br/>
  <br/>
  გაცნობებთ, რომ თქვენი რეკომენდაციების შესაბამისად, Beautyapp-ის განახლების პროცესის ფარგლებში, <strong>სამშაბათიდან, 22
  ივლისიდან</strong>, ჩაირთვება რამდენიმე ახალი ფუნქციონალი, რომელიც კიდევ უფრო გაამარტივებს სამუშაო პროცესის მართვას.
  ორგანიზაციის ელ.ფოსტაზე გამოგზავნილია ინსტრუქცია განახლებულ ფუნქციონალთან დაკავშირებით და გთხოვთ გაეცნოთ.
  <br/><br/><br/>
  დამატებითი ინფორმაციისთვის მიმართეთ მომხმარებელთა ზრუნვის დეპარტამენტს შემდეგ ნომრებზე: <br/><br/>
  591 047 393<br/>
  591 047 394<br/>
  0322 50 02 90
  <br/><br/><br/>
  <div class="flex justify-between items-center gap-4">
    <div class="flex flex-col gap-2">
      <div>ელექტრონული ანკეტა</div>
      <video  controls>
        <source src="https://media.webapp.ge/beautyapp/public/ანკეტა1.mp4" type="video/mp4">
        თქვენი ბრაუზერი არ უჭერს მხარს ვიდეოს ამ ფორმატში.
      </video>
    </div>

    <div class="flex flex-col gap-2">
      <div>ჯავშანი</div>
      <video  controls>
        <source src="https://media.webapp.ge/beautyapp/public/ჯავშანი.mp4" type="video/mp4">
        თქვენი ბრაუზერი არ უჭერს მხარს ვიდეოს ამ ფორმატში.
      </video>
    </div>

    <div class="flex flex-col gap-2">
      <div>დანიშნულების რეცეპტი</div>
      <video  controls>
        <source src="https://media.webapp.ge/beautyapp/public/რეცეპტი.mp4" type="video/mp4">
        თქვენი ბრაუზერი არ უჭერს მხარს ვიდეოს ამ ფორმატში.
      </video>
    </div>

  </div>
  <br/><br/><br/>
  პატივისცემით<br/>
  ვებაპის ადმინისტრაცია.
</div>
